const importKey = async fingerprint => {
  const key = new TextEncoder().encode(fingerprint)

  return window.crypto.subtle.importKey(
    'raw',
    key,
    {
      name: 'AES-GCM'
    },
    false,
    ['encrypt', 'decrypt']
  )
}

const write = (encryptedData, keyName) => {
  // encryptedData = new Uint8Array()
  const string = String.fromCharCode.apply(null, encryptedData.data)
  const stringIV = String.fromCharCode.apply(null, encryptedData.iv)
  const base64Data = btoa(string)
  const base64IV = btoa(stringIV)

  localStorage.setItem(keyName, base64Data)
  localStorage.setItem(`${keyName}IV`, base64IV)
}

const read = keyName => {
  try {
    const base64Data = localStorage.getItem(keyName)
    if (base64Data) {
      const base64IV = localStorage.getItem(`${keyName}IV`)
      const string = atob(base64Data)
      const stringIV = atob(base64IV)

      return {
        iv: new Uint8Array([...stringIV].map(char => char.charCodeAt(0))),
        data: new Uint8Array([...string].map(char => char.charCodeAt(0)))
      }
    }

    return false
  } catch (error) {
    console.error('Read Error: ', error)

    return false
  }
}

export const encrypt = async (text, fingerprint, keyName) => {
  try {
    const encodedText = new TextEncoder().encode(text)
    const key = await importKey(fingerprint)
    const iv = window.crypto.getRandomValues(new Uint8Array(12))

    const encryptedData = {
      iv,
      data: new Uint8Array(
        await window.crypto.subtle.encrypt(
          {
            name: 'AES-GCM',
            iv
          },
          key,
          encodedText
        )
      )
    }

    if (keyName) {
      write(encryptedData, keyName)

      return true
    }

    return encryptedData
  } catch (error) {
    console.error('Encrypt Error: ', error)
    localStorage.removeItem(keyName)

    return false
  }
}

export const decrypt = async (data, fingerprint) => {
  const key = await importKey(fingerprint)

  const decryptedData = await window.crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: data.iv
    },
    key,
    data.data
  )

  return new TextDecoder().decode(decryptedData)
}

export const decryptFromStore = async (keyName, fingerprint) => {
  try {
    const key = await importKey(fingerprint)
    const data = read(keyName)

    if (!data) return ''

    const decryptedData = await window.crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv: data.iv
      },
      key,
      data.data
    )

    return new TextDecoder().decode(decryptedData)
  } catch (error) {
    console.error('Decrypt Error: ', error)
    localStorage.removeItem(keyName)

    return false
  }
}
